import styled from "styled-components";

import { ProfileStoresStyledProps as Props } from "./ProfileStores.types";
import Modal from "components/global/Modal/Modal";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const ProfileStoresStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-black-s0-l10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr;
  grid-template-areas:
    "header header header"
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .ProfileStores {
    &__header {
      grid-area: header;
    }

    &__title {
      color: var(--palette-white);
      font-size: 2rem;
      padding-bottom: 2.4rem;
      font-weight: 700;
    }

    &__image {
      margin: 0 auto;
      margin-bottom: 2.4rem;
    }

    &__map {
      margin-bottom: 2.4rem;

      &--mobile {
        background-color: var(--palette-white);
        border-radius: 1.6rem;
        padding: 2.4rem;

        @media (min-width: ${desktop + 224}px) {
          display: none;
        }
      }
    }

    &__info {
      margin-left: 2.4rem;
      width: 64rem;
      min-width: 20rem;

      svg {
        margin-right: 0.8rem;

        path {
          fill: var(--palette-white);
        }
      }

      @media (max-width: ${desktop + 224}px) {
        display: none;
      }
    }

    &__static-map {
      display: flex;
      justify-content: center;

      .StaticMap__image {
        width: 100%;

        .Image__img {
          object-fit: cover !important;
        }
      }
    }

    &__list {
      width: 40rem;
      min-width: 28rem;

      @media (max-width: ${desktop + 224}px) {
        flex: 1;
      }
    }

    &__info,
    &__list {
      background-color: var(--palette-black-s2-l17);
      border-radius: 1.6rem;
      padding: 3.2rem 2.4rem;

      @media (max-width: ${tablet}px) {
        border: 0;
        max-width: 100%;
        padding: 2.4rem;
      }
    }

    &__search-bar {
      padding: 0 1.2rem;
      padding-bottom: 2rem;
      border-bottom: 0.1rem solid var(--palette-gray-s0-l25);

      @media (max-width: ${tablet}px) {
        padding: 0;
        padding-bottom: 1.2rem;
      }

      input {
        &.SearchBar__input {
          &:focus,
          &:hover:not([disabled]) {
            border: none;
          }
        }
      }

      .SearchBar {
        &__wrapper {
          border-radius: 0.8rem;
          overflow: hidden;
          background-color: var(--palette-black-s0-l4);
        }

        &__dropdown {
          max-width: 100%;
        }

        &__input {
          background-color: var(--palette-black-s0-l4) !important;
        }

        &__btn {
          background-color: var(--palette-black-s0-l4) !important;
        }
      }
    }

    &__text {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
      flex: 1;
      padding-left: 0.4rem;
      color: var(--palette-white);
    }

    &__section-title {
      margin-bottom: 0.8rem;
    }

    &__bottom {
      display: flex;
    }

    &__name {
      font-size: 1.6rem;
      font-weight: 700;
      padding-bottom: 3.6rem;
    }

    &__opened,
    &__location,
    &__phone {
      padding-bottom: 2.4rem;
    }

    &__location,
    &__phone {
      color: var(--palette-white);
    }

    &__opened,
    &__location,
    &__phone,
    &__time {
      font-size: 1.6rem;
      display: flex;
      align-items: center;
    }

    &__opened {
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      color: var(--palette-white);
    }

    &__point {
      width: 0.8rem;
      height: 0.8rem;
      background-color: var(--palette-red-s60-l60);
      border-radius: 90%;
      margin-right: 0.8rem;

      &--active {
        background-color: var(--palette-green-s100-l40);
      }
    }

    &__stores {
      border-radius: 1.6rem;

      .StorePreview__info,
      .InfoCard__icon-to-right {
        display: none;
      }
    }

    &__main {
      grid-area: main;
      padding-top: 8.8rem;
      margin-bottom: 3.2rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem minmax(4rem, 1fr);
        grid-template-rows: min-content max-content;
        grid-template-areas: "profile-navigation content";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__profile-navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
        margin-left: 4rem;
      }
    }

    &__content {
      grid-area: content;
      flex: 1;
      padding: 0 8rem;

      @media (max-width: ${desktop}px) {
        padding: 0 4rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        padding-left: 0;
        padding-top: 0;
      }
    }

    &__footer {
      grid-area: footer;
    }
  }

  &&& .SearchBar__input {
    padding: 1rem 1.2rem;
    border: none;
    line-height: 2.4rem;

    &:focus {
      box-shadow: none;
    }
  }
`;

export const ModalStyled = styled(Modal)`
  padding-top: 4.8rem;

  @media (max-width: ${mobile + 1}px) {
    padding-top: 3rem;
  }

  .Modal__body {
    padding: 0 2.4rem;

    @media (max-width: ${mobile + 1}px) {
      padding-left: 0 2rem;
    }
  }

  .ProfileStores {
    &__info {
      svg {
        margin-right: 0.8rem;
      }
    }

    &__static-map {
      @media (max-width: ${tablet + 1}px) {
        margin: 2rem 0 3rem 0;
      }
    }

    &__text {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
      flex: 1;
      padding-left: 0.4rem;
      font-size: 1.4rem;
    }

    &__image {
      margin: 0 auto;
      margin-bottom: 2.4rem;
    }

    &__opened,
    &__location,
    &__phone {
      padding-bottom: 2.4rem;
    }

    &__opened,
    &__location,
    &__phone,
    &__time {
      font-size: 1.4rem;
      display: flex;
      align-items: center;
    }

    &__opened {
      display: flex;
      align-items: center;
      font-size: 1.4rem;
    }

    &__point {
      width: 0.8rem;
      height: 0.8rem;
      background-color: var(--palette-red-s60-l60);
      border-radius: 90%;
      margin-right: 0.8rem;

      &--active {
        background-color: var(--palette-green-s100-l40);
      }
    }
  }
`;

export default ProfileStoresStyled;
